<template>
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <li :class="{ 'page-item': true, 'disabled': currentPage === 1}">
        <a href="#" class="page-link" @click="onFirstClick" aria-label="First page">
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">First page</span>
        </a>
      </li>
      <li :class="{ 'page-item': true, 'disabled': currentPage === 1}">
        <a href="#" class="page-link" @click="onPreviousClick" aria-label="Previous page">
          <span aria-hidden="true">&lsaquo;</span>
          <span class="sr-only">Previous page</span>
        </a>
      </li>
      <li
        :class="{ 'page-item': true, 'active': currentPage === page}"
        v-for="page in getCurrentPages"
        :key="`page-${page}`"
      >
        <a href="#" class="page-link" @click="onPageClick($event, page)">{{ page }}</a>
      </li>
      <li :class="{ 'page-item': true, 'disabled': currentPage === this.getPageAmount}">
        <a href="#" class="page-link" @click="onNextClick" aria-label="Next page">
          <span aria-hidden="true">&rsaquo;</span>
          <span class="sr-only">Next page</span>
        </a>
      </li>
      <li :class="{ 'page-item': true, 'disabled': currentPage === this.getPageAmount}">
        <a href="#" class="page-link" @click="onLastClick" aria-label="Last page">
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">Last page</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',

  props: {
    currentPage: {
      type: Number,
      default: 1,
      required: true,
    },

    itemCount: {
      type: Number,
      default: 0,
      required: true,
    },

    itemsPerPage: {
      type: Number,
      default: 10,
      required: false,
    },

    maxPages: {
      type: Number,
      default: 5,
      required: false,
    },
  },

  computed: {
    getPageAmount() {
      return Math.ceil(this.itemCount / this.itemsPerPage);
    },

    getPageOffset() {
      return Math.floor(this.maxPages / 2);
    },

    getCurrentPages() {
      const pages = [];
      const endDiff =
        this.getPageAmount - this.currentPage - this.getPageOffset < 0
          ? this.getPageAmount - this.currentPage - this.getPageOffset
          : 0;
      let start =
        this.currentPage - this.getPageOffset < 1
          ? 1
          : this.currentPage - this.getPageOffset;
      let end = start + this.maxPages;
      start += endDiff;
      end += endDiff;
      if (this.getPageAmount < this.maxPages) {
        start = 1;
        end = this.getPageAmount + 1;
      }
      for (start; start < end; start += 1) {
        const page = start;
        pages.push(page);
      }

      return pages;
    },
  },

  methods: {
    emitEvent(page) {
      this.$emit('pagination:go-to-page', page);
    },

    onFirstClick(evt) {
      evt.preventDefault();
      this.$emit('pagination:go-to-page', 1);
    },

    onLastClick(evt) {
      evt.preventDefault();
      this.$emit('pagination:go-to-page', this.getPageAmount);
    },

    onNextClick(evt) {
      evt.preventDefault();
      if (this.currentPage !== this.getPageAmount) {
        this.emitEvent(this.currentPage + 1);
      }
    },

    onPreviousClick(evt) {
      evt.preventDefault();
      if (this.currentPage !== 1) {
        this.emitEvent(this.currentPage - 1);
      }
    },

    onPageClick(evt, page) {
      evt.preventDefault();
      if (this.currentPage !== page) {
        this.emitEvent(page);
      }
    },
  },
};
</script>
